import { cn } from "@/lib/utils/global-utils";
import React from "react";

interface CircleProgressProps
  extends React.HtmlHTMLAttributes<HTMLDivElement> {
    progress: number
  }

const CircleProgress = React.forwardRef<HTMLDivElement, CircleProgressProps>(
  ({ className,progress, ...rest }, ref) => {
    return (
      <div {...rest} ref={ref} className={cn("relative size-40", className)}>
        <svg
          className="size-full -rotate-90"
          viewBox="0 0 36 36"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="18"
            cy="18"
            r="16"
            fill="none"
            className="stroke-current text-gray-200 "
            strokeWidth="4"
          ></circle>

          <circle
            cx="18"
            cy="18"
            r="16"
            fill="none"
            className="stroke-current text-lewk-primary transition-all duration-1000"
            strokeWidth="4"
            strokeDasharray="100"
            strokeDashoffset={`${100-progress}`}
            strokeLinecap="round"
          ></circle>
        </svg>
      </div>
    );
  }
);

CircleProgress.displayName =  "Circle Progress"
export default CircleProgress;
